import * as defaultImport from "@splunk/react-ui/StepBar";
export * from "@splunk/react-ui/StepBar";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
